export default function CostSummaryTableColumns() {
	return [
		{
			name: "num",
			title: "№ п/п",
			width: "30px",
			cellHorAlign: "center",
			headHorAlign: "center",
			headHeight: "30px",
			marginLeft: "0px",
			rowSpan: "2",
		},
		{
			name: "reason",
			title: "Обосно вание",
			width: "60px",
			cellHorAlign: "left",
			headHorAlign: "left",
			headHeight: "30px",
			marginLeft: "0px",
			rowSpan: "2",
		},
		{
			name: "name",
			title: "Наименование затрат",
			width: "170px",
			cellHorAlign: "left",
			headHorAlign: "left",
			headHeight: "30px",
			marginLeft: "0px",
			rowSpan: "2",
		},
		{
			name: "cost",
			title: "Сметная стоимость, руб.",
			width: "1050px",
			cellHorAlign: "left",
			headHorAlign: "center",
			headHeight: "25px",
			colSpan: "11",
			children: [
				{
					name: "direct",
					title: "Прямые затраты",
					width: "100px",
					cellHorAlign: "right",
					headHorAlign: "center",
					headHeight: "30px",
					marginLeft: "0px",
				},
				{
					name: "worker_salary",
					title: "в т.ч. ОТ",
					width: "100px",
					cellHorAlign: "right",
					headHorAlign: "center",
					headHeight: "30px",
					marginLeft: "0px",
				},
				{
					name: "machines",
					title: "в т.ч. ЭМ",
					width: "100px",
					cellHorAlign: "right",
					headHorAlign: "center",
					headHeight: "30px",
					marginLeft: "0px",
				},
				{
					name: "machinist_salary",
					title: "в т.ч. ОТМ",
					width: "100px",
					cellHorAlign: "right",
					headHorAlign: "center",
					headHeight: "30px",
					marginLeft: "0px",
				},
				{
					name: "materials",
					title: "в т.ч. МАТ",
					width: "100px",
					cellHorAlign: "right",
					headHorAlign: "center",
					headHeight: "30px",
					marginLeft: "0px",
				},
				{
					name: "transport",
					title: "в т.ч. перевозка",
					width: "100px",
					cellHorAlign: "right",
					headHorAlign: "center",
					headHeight: "30px",
					marginLeft: "0px",
				},
				{
					name: "equipment",
					title: "ОБ",
					width: "100px",
					cellHorAlign: "right",
					headHorAlign: "center",
					headHeight: "30px",
					marginLeft: "0px",
				},
				{
					name: "salary",
					title: "ФОТ",
					width: "100px",
					cellHorAlign: "right",
					headHorAlign: "center",
					headHeight: "30px",
					marginLeft: "0px",
				},
				{
					name: "overhead",
					title: "НР",
					width: "100px",
					cellHorAlign: "right",
					headHorAlign: "center",
					headHeight: "30px",
					marginLeft: "0px",
				},
				{
					name: "profit",
					title: "СП",
					width: "100px",
					cellHorAlign: "right",
					headHorAlign: "center",
					headHeight: "30px",
					marginLeft: "0px",
				},
				{
					name: "total",
					title: "Итого",
					width: "100px",
					cellHorAlign: "right",
					headHorAlign: "center",
					headHeight: "30px",
					marginLeft: "0px",
				},
			],
		},
		{
			name: "lab",
			title: "Затраты труда, чел.-ч",
			width: "130px",
			cellHorAlign: "left",
			headHorAlign: "center",
			headHeight: "25px",
			colSpan: "2",
			children: [
				{
					name: "labor_costs",
					title: "ЗТ",
					width: "65px",
					cellHorAlign: "right",
					headHorAlign: "center",
					headHeight: "30px",
					marginLeft: "0px",
				},
				{
					name: "machinist_labor_costs",
					title: "ЗТМ",
					width: "65px",
					cellHorAlign: "right",
					headHorAlign: "center",
					headHeight: "30px",
					marginLeft: "0px",
				},
			],
		},
	];
}
